$(document).on("turbolinks:load", function () {
  var $loginForm = $(".js-login-form")
  if ($loginForm.length > 0) {
    $loginForm.on("submit", function () {
      // validate the captcha is filled
      if (window.RAILS_ENV === "test" || window.RAILS_ENV === "development") {
        return true
      }

      var googleResponse = $("#g-recaptcha-response").val()
      if (!googleResponse) {
        return false
      }
      return true
    })
  }
})
